import React from 'react';
import ViewAllPresentational from './view-all-presentational';

const VideoALLFunctional = () => {
	return <ViewAllPresentational />;
};

export default VideoALLFunctional;
